<template>
  <v-container grid-list-md fluid class="pa-0">
        <v-layout>
            <v-flex>
                <v-img size="36px" :src="coverPhoto" class="CoverPhoto card-r"></v-img>
              <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">edit</v-icon></v-btn>-->
              <v-btn v-bind:to="'/admin/edit/'+user.id" flat color="grey" class="text-xs-right right ma-0 shadow-1" icon ><v-icon class="px-2">edit</v-icon></v-btn>
              <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">delete</v-icon></v-btn>-->
              <!--<v-btn icon flat color="grey" to="/signup" class="text-xs-right right"><v-icon class="px-2">block</v-icon></v-btn>-->
            </v-flex>
        </v-layout>
        <v-layout row class="text-md-center">
            <v-flex xs12 class="profileImgd">
                <v-img :src="ProfileImg" class="boxShadow"></v-img>
            </v-flex>
        </v-layout>
      <v-container fluid grid-list-xl class="pt-0 grey lighten-4 card-r">
        <v-layout row wrap class="">
          <v-flex d-flex lg12 sm12 xs12>
            <div class="text-xs-center">
              <span class="headline font-weight-black text-capitalize">{{user.name}}</span> <br>
              <span class="subheading font-weight-light text-capitalize"> (Learn Fast and Drive Fast)
                </span>
              <p class="text-xs-left">
                A driving instructor is responsible for teaching students the rules of the road and the safe way to handle an automobile. Driving instructor jobs are available in a variety of settings. Some schools offer driver's training to high school students preparing to get a driver's license for the first time
              </p>
            </div>
          </v-flex>
          <span class="f-15 text-primary font-weight-bold">Admin Details</span>
          <v-layout row wrap class="">
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0 shadow-1 card-r">
              <v-layout row class="ma-0">
                <v-flex xs6 class="label pa-0"><p> Full Name </p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0 pa-0">{{user.name}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0 white shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs2 class="label pa-0"><p>Email</p> </v-flex>
                <v-flex xs12 class="word-break text-xs-right pa-0">{{user.email}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Phone Number</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">+45{{user.phone}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Date of Birth</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{user.dob}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs2 class="label pa-0"><p>Address</p> </v-flex>
                <v-flex xs10 class="word-break text-xs-right pa-0">{{UserAddress}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>City</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{user.city}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Zip Code</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{user.zipCode}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex d-flex lg4 sm6 xs12 class="pb-0">
            <v-card class="PersonalCards pa-0  shadow-1 card-r">
              <v-layout row class="ma-0 ">
                <v-flex xs6 class="label pa-0"><p>Gender</p> </v-flex>
                <v-flex xs6 class="word-break text-xs-right pa-0">{{user.gender}}</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          </v-layout>
          <div class="f-15 text-primary font-weight-bold mt-2">School Details</div>
          <v-layout row wrap class="">
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards    shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p> Full Name </p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">{{user.name}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0 shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs2 class="label pa-0"><p>Email</p> </v-flex>
                  <v-flex xs10 class="word-break text-xs-right pa-0">{{user.email}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p>Phone Number</p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">+45{{user.phone}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p>Date of Birth</p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">{{user.dob}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs2 class="label pa-0"><p>Address</p> </v-flex>
                  <v-flex xs10 class="word-break text-xs-right pa-0">{{UserAddress}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p>City</p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">{{user.city}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p>Zip Code</p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">{{user.zipCode}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex d-flex lg4 sm6 xs12 class="pb-0">
              <v-card class="PersonalCards pa-0  shadow-1 card-r">
                <v-layout row class="ma-0 ">
                  <v-flex xs6 class="label pa-0"><p>Gender</p> </v-flex>
                  <v-flex xs6 class="word-break text-xs-right pa-0">{{user.gender}}</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

        </v-layout>
      </v-container>
        <!--</v-layout>-->
    </v-container>
</template>

<script>
/* eslint-disable */
  import { mapState, dispatch } from 'vuex'

export default {
    name: "personal",
    data: () => ({
        coverPhoto: "https://prodwpids-idrivesafely.netdna-ssl.com/wp-content/themes/enterprise-pro/images/insurance-portal/Insurance_Woman_Driver.jpg",
        ProfileImg: "https://m.sephora.ae/wysiwyg/brands/500x500_BOSS_BOTTLED_Gearshift.jpg",
        UserAddress:''
    }),
    computed:{
        ...mapState({

        user: 'user',
        loading: 'loading',
        mode: 'mode'
      }),
  },
  methods:{
      nullCheck(value){
        if(value){
          return value+' ';
        }else{
          return ""
        }
      },
  },
  mounted:function(){
      // this.$router.push({ path:`/Profile` })
      this.UserAddress=this.nullCheck(Store.state.user.street)+' '+
                    this.nullCheck(Store.state.user.streetNumber)+' '+
                    this.nullCheck(Store.state.user.floor)+' '+
                    this.nullCheck(Store.state.user.door)+' '+
                    this.nullCheck(Store.state.user.zipCode)+' '+
                    this.nullCheck(Store.state.user.city)
  },

};
</script>



// WEBPACK FOOTER //
// src/components/profile/admin/AdminPersonal.vue